<template>
  <div>
    <filter-toolbar
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      @search="search"
      @update="update"
      @clear="clear">
      <facet-filter
        class="border-b"
        v-model="filters.facets.status"
        :filter="filterOptions.status"
        @input="change"
      />
      <facet-filter
        class="border-b"
        v-model="filters.facets.topic"
        :filter="filterOptions.topic"
        @input="change"
      />
      <date-filter
        v-model="filters.timestamps.created_at"
        :filter="filterOptions.createdAt"
        @input="change"
      />
    </filter-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as filterOptions from '../../filters/WoocommerceWebhooks.js'
import FilterToolbar from '@/components/Filters/FilterToolbar'
import DateFilter from '@/components/Filters/DateFilter'
import FacetFilter from '@/components/Filters/FacetFilter'

export default {
  components: {
    DateFilter,
    FacetFilter,
    FilterToolbar
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      // filters
      filterOptions: filterOptions
    }
  },
  computed: {
    ...mapGetters(['context'])
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchQuery) {
      this.filters.search = {
        parameter: 'payload',
        query: searchQuery
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  mounted () {

  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
